// extracted by mini-css-extract-plugin
export default {"layout":"StorageLayout_layout__i6JRY"};